import { styled } from '@core-ui/react-stitch';

const GridBannerContainer = styled.div(({isBRRedesignEnabled}) => ({ ...!isBRRedesignEnabled && { padding: "0"} }));

export default GridBannerContainer;